// extracted by mini-css-extract-plugin
module.exports = {"link":"Result_link_WtWv3","listTitle":"Result_listTitle_3IHdt"};
    if(module.hot) {
      // 1789136761673
      var cssReload = require("/drone/src/node_modules/@vue/cli-service/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"../","locals":true});
      module.hot.dispose(cssReload);
      
    }
  